import React, { useState } from "react";
import axios from "../../api/axios";
import ReportFilterBar from "../../components/reports/ReportFilterBar";
import ReportTable from "../../components/reports/ReportTable";

export default function ProjectSummaryReport() {
  const [rows, setRows] = useState([]);

  const fetchData = async () => {
    try {
      const res = await axios.get("/api/reports/project-summary");

      const data = res.data.rows || res.data.data || res.data || [];
      setRows(data);
    } catch (err) {
      console.error(err);
      setRows([]);
    }
  };

  const columns = [
    { field: "project", header: "Project" },
    { field: "total_hours", header: "Total Hours" }
  ];

  return (
    <>
      <h2>Project Summary</h2>

      <ReportFilterBar
        filters={[]}
        values={{}}
        onChange={() => {}}
        onFetch={fetchData}
      />

      <ReportTable columns={columns} rows={rows} />
    </>
  );
}